<template>
  <div class="internet-auth-list">
    <!-- 标签页切换 -->
    <div class="tab-container">
      <div
        class="tab-item"
        :class="{ active: activeTab === 'pending' }"
        @click="switchTab('pending')"
      >
        <p>
          待认证{{ pendingList.length > 0 ? `(${pendingList.length})` : "" }}
        </p>
      </div>
      <div
        class="tab-item"
        :class="{ active: activeTab === 'completed' }"
        @click="switchTab('completed')"
      >
        <p>
          已认证{{
            completedList.length > 0 ? `(${completedList.length})` : ""
          }}
        </p>
      </div>
    </div>

    <!-- 提示信息 -->
    <div class="notice-container">
      <van-notice-bar
        color="#FD8D32"
        background="#FFEEE0"
        left-icon="info-o"
        wrapable
      >
        如当前设备使用的是移动网络，连接设备每隔30天需做一次认证，未及时认证将无法使用网络！
      </van-notice-bar>
    </div>

    <!-- 列表内容 -->
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <div class="list-container">
        <div
          v-for="(item, index) in currentList"
          :key="`${activeTab}-${item.terminalMac}-${index}`"
          class="list-item"
        >
          <div class="item-header">
            <div class="device-info">
              <div class="mac-address">
                <span class="label">MAC</span>
                <span class="value">{{ item.terminalMac }}</span>
              </div>
              <div class="remark">
                <span class="label">备注</span>

                <div class="remark-content" @click="updateName(item)">
                  <span class="value clickable">{{
                    item.remark || "修改"
                  }}</span>
                  <van-icon name="arrow" color="var(--primary-color)" />
                </div>
              </div>
            </div>
            <van-button
              type="primary"
              size="small"
              @click.stop="handleAuth(item)"
              class="auth-btn"
            >
              去认证
            </van-button>
          </div>
          <div class="item-content">
            <div class="network-info">
              <div class="network-info-item">
                <img
                  src="@/assets/images/home/yidong.png"
                  class="network-icon"
                />
                <span class="network-type">{{ item.networkType }}</span>
              </div>

              <span class="expire-time">
                <span v-if="item.cmCertifyState === 'N'" class="noauth-time"
                  >未认证</span
                >
                <span v-else>
                  {{ item.cmExpireTime.split(" ")?.[0] || item.cmExpireTime
                  }}<span style="color: #333; margin-left: 10px">到期</span>
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </van-pull-refresh>

    <!-- 空状态 -->
    <div v-if="currentList.length === 0" class="empty-state">
      <van-empty description="暂无数据" />
    </div>

    <!-- 修改备注弹窗 -->
    <van-popup
      v-model="showUpdateName"
      position="center"
      round
      class="update-name-popup"
    >
      <div class="popup-content">
        <div class="popup-header">
          <h3 class="popup-title">修改备注</h3>
        </div>
        <div class="popup-body">
          <div class="input-group">
            <p class="input-label">备注</p>
            <van-field
              v-model="updateNameValue"
              placeholder="请输入备注"
              class="remark-input"
              maxlength="10"
            />
          </div>
        </div>
        <div class="popup-footer">
          <van-button class="cancel-btn" @click="cancelUpdateName">
            取消
          </van-button>
          <van-button
            type="primary"
            class="confirm-btn"
            @click="confirmUpdateName"
          >
            保存
          </van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { getWirelessTerminalList, updateTerminalRemark } from "@/api/home";
import {
  Toast,
  NoticeBar,
  PullRefresh,
  Button,
  Empty,
  Icon,
  Popup,
  Field,
} from "vant";

export default {
  components: {
    // [NoticeBar.name]: NoticeBar,
    // [PullRefresh.name]: PullRefresh,
    // [Button.name]: Button,
    // [Empty.name]: Empty,
    // [Icon.name]: Icon,
    // [Popup.name]: Popup,
    // [Field.name]: Field,
  },

  data() {
    return {
      sn: "",
      activeTab: "pending",
      pendingList: [],
      completedList: [],
      refreshing: false,
      showUpdateName: false,
      updateNameValue: "",
      currentEditItem: null,
    };
  },

  computed: {
    currentList() {
      return this.activeTab === "pending"
        ? this.pendingList
        : this.completedList;
    },
  },

  mounted() {
    this.initData();
    this.loadInitialData();
  },

  methods: {
    initData() {
      this.sn = this.$route.query.sn;
    },

    updateName(item) {
      this.currentEditItem = item;
      this.updateNameValue = item.remark || "";
      this.showUpdateName = true;
    },

    switchTab(tab) {
      if (this.activeTab === tab) return;
      this.activeTab = tab;
      if (this.currentList.length === 0) {
        this.loadData();
      }
    },

    async loadInitialData() {
      await this.loadData();
    },

    async loadData() {
      if (this.activeTab === "pending") {
        await this.loadPendingList();
      } else {
        await this.loadCompletedList();
      }
    },

    async loadPendingList() {
      const res = await getWirelessTerminalList({
        sn: this.sn,
        certifyState: "N",
      });
      const list = res.map((item) => ({
        id: item.id,
        sn: item.sn,
        mac: item.mac,
        terminalMac: item.terminalMac,
        cmCertifyState: item.cmCertifyState,
        cmExpireTime: item.cmExpireTime,
        remark: item.remark,
        networkType: "移动",
      }));
      this.pendingList = list;
    },

    async loadCompletedList() {
      const res = await getWirelessTerminalList({
        sn: this.sn,
        certifyState: "Y",
      });
      const list = res.map((item) => ({
        id: item.id,
        sn: item.sn,
        mac: item.mac,
        terminalMac: item.terminalMac,
        cmCertifyState: item.cmCertifyState,
        cmExpireTime: item.cmExpireTime,
        remark: item.remark,
        networkType: "移动",
      }));
      this.completedList = list;
    },

    async onRefresh() {
      this.refreshing = true;
      if (this.activeTab === "pending") {
        this.pendingList = [];
      } else {
        this.completedList = [];
      }
      await this.loadData();
      this.refreshing = false;
    },

    handleAuth(item) {
      this.uni.navigateTo(
        "/home/InternetAuthentication?sn=" +
          this.sn +
          "&deviceRemark=" +
          item.remark +
          "&mac=" +
          item.mac +
          "&terminalMac=" +
          item.terminalMac +
          "&id=" +
          item.id
      );
    },

    //修改备注
    confirmUpdateName() {
      if (!this.updateNameValue) {
        Toast("请输入备注");
        return;
      }

      if (this.currentEditItem) {
        updateTerminalRemark({
          sn: this.currentEditItem.sn,
          deviceMac: this.currentEditItem.mac,
          terminalMac: this.currentEditItem.terminalMac,
          remark: this.updateNameValue,
        }).then((res) => {
          this.currentEditItem.remark = this.updateNameValue;
          Toast("备注已更新");
          this.showUpdateName = false;
          this.currentEditItem = null;
        });
      }
    },

    cancelUpdateName() {
      this.showUpdateName = false;
      this.currentEditItem = null;
    },
  },
};
</script>

<style lang="less" scoped>
.internet-auth-list {
  min-height: 100vh;
  background-color: #f5f5f5;
  padding-top: 200px;
}

.tab-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  display: flex;
  background-color: #fff;
  padding-bottom: 20px; /* 为下划线留出空间 */
  height: 60px;

  .tab-item {
    flex: 1;
    text-align: center;
    padding: 16px 0;
    cursor: pointer;
    transition: all 0.3s;
    position: relative;
    font-size: 30px;

    p {
      margin: 0;
      color: #848992;
    }

    &.active {
      p {
        color: #24262b;
        font-weight: bold;
      }

      &::after {
        content: "";
        position: absolute;
        bottom: -10px;
        left: 50%;
        transform: translateX(-50%);
        width: 60px;
        height: 8px;
        background-color: var(--primary-color);
        border-radius: 4px;
      }
    }
  }
}

.notice-container {
  position: fixed;
  top: 80px;
  left: 0;
  right: 0;
  z-index: 99;
  height: 100px;
}

.list-container {
  padding: 24px;
}

.list-item {
  background-color: #fff;
  border-radius: 16px;
  margin-bottom: 24px;
  padding: 32px 30px;

  .item-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 24px;

    .device-info {
      flex: 1;

      .mac-address {
        display: flex;
        align-items: center;
        margin-bottom: 12px;
        font-size: 30px;
        color: #868686;

        .label {
          color: #868686;
          width: 140px;
          margin-right: 30px;
        }

        .value {
          color: #333;
        }
      }

      .remark {
        display: flex;
        align-items: center;
        padding-top: 12px;
        font-size: 30px;
        color: #868686;
        .label {
          color: #868686;
          width: 140px;
          margin-right: 30px;
        }

        .value {
          color: var(--primary-color);
          &.clickable {
            cursor: pointer;
          }
        }
        .remark-content {
          font-size: 30px;
          display: flex;
          align-items: center;
        }
      }
    }

    .auth-btn {
      background-color: var(--primary-color);
      border-color: var(--primary-color);
      color: #fff;
      padding: 8px 16px;
      height: 52px;
      line-height: 52px;
      border-radius: 8px;
      font-size: 26px;
    }
  }

  .item-content {
    .network-info {
      display: flex;
      align-items: center;
      font-size: 30px;
      color: #868686;

      .network-info-item {
        display: flex;
        align-items: center;
        width: 140px;
        margin-right: 30px;

        .network-icon {
          width: 38px;
          height: 38px;
        }

        .network-type {
          font-size: 30px;
          color: #868686;
        }
      }

      .expire-time {
        color: #ff3831;
        min-width: 80px;
        margin-right: 0;
        flex-shrink: 0;
      }
    }

    .noauth-time {
      background-color: #f5f6fa;
      border-radius: 6px;
      padding: 2px 12px;
      font-size: 24px;
      color: #868686;
    }
  }
}

.empty-state {
  padding: 60px 0;
}

.update-name-popup {
  width: 80%;

  .popup-content {
    background-color: #fff;
    border-radius: 16px;
    overflow: hidden;

    .popup-header {
      padding: 32px 32px 24px 32px;
      text-align: center;

      .popup-title {
        margin: 0;
        font-size: 34px;
        font-weight: bold;
        color: #333;
      }
    }

    .popup-body {
      padding: 0px 32px 32px 32px;

      .input-group {
        display: flex;
        flex-direction: row;
        align-items: center;

        .input-label {
          font-size: 30px;
          color: #333;
          margin-right: 20px;
          white-space: nowrap;
          flex-shrink: 0;
        }

        .remark-input {
          flex: 1;

          :deep(.van-field__control) {
            font-size: 30px;
            color: #333;
            padding: 20px;
            background-color: #f2f5fa;
            border-radius: 16px;
          }
        }
      }
    }

    .popup-footer {
      display: flex;
      border-top: 1px solid #f5f5f5;

      .cancel-btn,
      .confirm-btn {
        flex: 1;
        height: 88px;
        line-height: 88px;
        font-size: 32px;
        border: none;
        border-radius: 0;
      }

      .cancel-btn {
        background-color: #fff;
        color: #999999;
        border-right: 1px solid #f5f5f5;
      }

      .confirm-btn {
        background-color: #fff;
        color: var(--primary-color);
      }
    }
  }
}
</style>
